export const LANGS = [
  { code: "nl", label: "NL" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

export const translations = {
  nl: {
    announcement: "Introductieprijs €32,50 (i.p.v. €40) · Gratis verzending vanaf €60",
    nav: { product: "Product", ingredients: "Ingrediënten", reviews: "Reviews", faq: "FAQ", contact: "Contact", cart: "Winkelwagen", menu: "Menu" },
    hero: {
      eyebrow: "Nieuw van MKB Performance",
      title: "ZENKAI Pre-Workout",
      sub: "Pre-workout met 9 ingrediënten en volledig vermelde doseringen. Wat erin zit, staat op het etiket — niets meer, niets minder.",
      cta: "Bekijk ZENKAI",
      cta2: "Bekijk ingrediënten",
      from: "Vanaf",
      perTub: "per pot (20 porties)",
    },
    trust: [
      { title: "Snelle verzending", desc: "Bestellingen worden doorgaans binnen 1–2 werkdagen verzonden." },
      { title: "14 dagen retour", desc: "Ongeopende producten kun je binnen 14 dagen retourneren." },
      { title: "Veilig betalen", desc: "Bancontact, PayPal, Klarna en kaart via Shopify Checkout." },
    ],
    product: {
      title: "Kies je smaak",
      sub: "Eén formule, twee smaken. Dezelfde ingrediënten en doseringen in elke pot.",
      flavorNote: { tropical: "Tropisch fruit, zoet-fris", apple: "Groene appel, fris-zuur" },
      qty: "Aantal",
      add: "In winkelwagen",
      was: "Adviesprijs",
      discount: "−19%",
      facts: ["20 porties per pot", "400 g netto", "300 mg cafeïne per portie", "Volledig vermelde doseringen"],
      bundle: "Tip: 2 potten = gratis verzending",
      shipping: "Verzendkosten worden berekend bij het afrekenen.",
    },
    ingredients: {
      title: "Wat zit erin",
      sub: "Per portie van 1 scoop (20 g). Geen propriëtaire blends: elke hoeveelheid staat hieronder en op het etiket.",
      perServing: "per portie",
      other: "Overige ingrediënten: natuurlijke aroma's, citroenzuur, zoetstof (sucralose), natuurlijk kleurstof, antiklontermiddel (siliciumdioxide).",
      items: {
        citrulline: "Verbinding van het aminozuur L-citrulline en appelzuur in een 2:1-verhouding.",
        beta_alanine: "Aminozuur. Kan kort na inname een tijdelijk tintelend gevoel geven (paresthesie). Dit is onschadelijk en verdwijnt vanzelf.",
        betaine: "Trimethylglycine in HCl-vorm, van nature aanwezig in onder andere bieten.",
        taurine: "Aminozuur dat van nature in het lichaam en in voeding voorkomt.",
        maltodextrin: "Snel verteerbaar koolhydraat uit zetmeel.",
        caffeine: "Cafeïne in watervrije vorm. 300 mg per portie — vergelijkbaar met ongeveer drie kopjes koffie.",
        theanine: "Aminozuur dat van nature in groene thee voorkomt.",
        salt: "Natuurlijk zout, bron van natrium en spoormineralen.",
        astragin: "Gepatenteerd plantenextract van Astragalus membranaceus en Panax notoginseng.",
      },
    },
    usage: {
      title: "Gebruik",
      steps: [
        { title: "Mengen", desc: "Meng 1 scoop (20 g) met 300–400 ml koud water en schud goed." },
        { title: "Timing", desc: "Neem 20–30 minuten voor je training." },
        { title: "Dosering", desc: "Maximaal 1 portie per dag. Nieuw met pre-workout? Begin met een halve scoop." },
      ],
      warning: "Bevat 300 mg cafeïne per portie. Niet geschikt voor kinderen, zwangere vrouwen, vrouwen die borstvoeding geven en personen die gevoelig zijn voor cafeïne. Voedingssupplement: niet gebruiken als vervanging van een gevarieerde, evenwichtige voeding en een gezonde levensstijl. Buiten bereik van kinderen bewaren.",
    },
    reviews: {
      title: "Reviews",
      sub: "Ervaringen van klanten. Heb je ZENKAI geprobeerd? Deel je mening.",
      empty: "Nog geen reviews. Wees de eerste die er één schrijft.",
      count: "{n} reviews",
      countOne: "1 review",
      average: "gemiddeld",
      badge: "Klantreview",
      write: "Schrijf een review",
      cancel: "Annuleren",
      name: "Naam",
      sport: "Sport (optioneel)",
      flavor: "Smaak",
      rating: "Beoordeling",
      text: "Jouw ervaring",
      textPlaceholder: "Wat vond je van de smaak, het gebruik en de bestelling? Min. 10 tekens.",
      submit: "Review plaatsen",
      sending: "Verzenden…",
      thanks: "Bedankt! Je review staat online.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      tooMany: "Je hebt net een review geplaatst. Probeer het over 2 minuten opnieuw.",
      validation: "Vul je naam in, kies een score en schrijf minstens 10 tekens.",
    },
    faq: {
      title: "Veelgestelde vragen",
      items: [
        { q: "Waarom tintelt mijn huid na inname?", a: "Dat komt door beta-alanine (paresthesie). Het is onschadelijk, verdwijnt na 20–30 minuten en neemt meestal af bij regelmatig gebruik." },
        { q: "Hoeveel cafeïne zit er in één portie?", a: "300 mg per scoop. Neem niet meer dan 1 portie per dag en houd rekening met andere cafeïnebronnen zoals koffie of energiedrank." },
        { q: "Wanneer wordt mijn bestelling verzonden?", a: "Doorgaans binnen 1–2 werkdagen. Levertijd in BE/NL is meestal 1–3 werkdagen." },
        { q: "Kan ik retourneren?", a: "Ongeopende producten kun je binnen 14 dagen na ontvangst retourneren. Neem contact op via info@mkbperformance.com." },
        { q: "Hoe wordt de betaling afgehandeld?", a: "Je rekent af via Shopify Checkout met Bancontact, PayPal, Klarna of kaart. Verzendkosten zie je vóór je betaalt." },
      ],
    },
    contact: {
      title: "Contact",
      sub: "Vraag over je bestelling, het product of iets anders? Stuur een bericht — we antwoorden meestal binnen 1 werkdag.",
      name: "Naam",
      email: "E-mailadres",
      message: "Je vraag",
      messagePlaceholder: "Waar kunnen we je mee helpen?",
      send: "Verstuur bericht",
      sending: "Verzenden…",
      thanks: "Bedankt! Je bericht is verzonden. We nemen contact met je op via e-mail.",
      error: "Er ging iets mis. Probeer het opnieuw of mail ons rechtstreeks.",
      tooMany: "Je hebt net een bericht gestuurd. Probeer het over een minuut opnieuw.",
      validation: "Vul je naam, een geldig e-mailadres en een bericht van minstens 10 tekens in.",
      or: "Of mail rechtstreeks naar",
    },
    newsletter: {
      title: "Als eerste nieuwe smaken horen?",
      sub: "Laat je e-mail achter. We mailen alleen bij nieuwe producten, smaken of acties — geen spam.",
      placeholder: "jouw@email.com",
      cta: "Inschrijven",
      sending: "Even geduld…",
      thanks: "Je staat op de lijst. Tot snel!",
      already: "Dit adres staat al ingeschreven.",
      invalid: "Vul een geldig e-mailadres in.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      privacy: "Uitschrijven kan altijd. We delen je adres nooit.",
    },
    footer: { rights: "© 2026 MKB Performance", contact: "Contact", email: "info@mkbperformance.com", legal: "Algemene voorwaarden · Privacy · Retourbeleid" },
    cart: {
      title: "Winkelwagen",
      empty: "Je winkelwagen is leeg.",
      subtotal: "Subtotaal",
      shippingNote: "Verzendkosten worden berekend bij het afrekenen",
      shippingAway: "Nog {amount} tot gratis verzending",
      shippingFree: "Gratis verzending",
      checkout: "Afrekenen",
      continue: "Verder winkelen",
    },
  },
  en: {
    announcement: "Launch price €32.50 (was €40) · Free shipping over €60",
    nav: { product: "Product", ingredients: "Ingredients", reviews: "Reviews", faq: "FAQ", contact: "Contact", cart: "Cart", menu: "Menu" },
    hero: {
      eyebrow: "New from MKB Performance",
      title: "ZENKAI Pre-Workout",
      sub: "Pre-workout with 9 ingredients and fully disclosed doses. What's inside is on the label — nothing more, nothing less.",
      cta: "View ZENKAI",
      cta2: "See ingredients",
      from: "From",
      perTub: "per tub (20 servings)",
    },
    trust: [
      { title: "Fast shipping", desc: "Orders usually ship within 1–2 business days." },
      { title: "14-day returns", desc: "Unopened products can be returned within 14 days." },
      { title: "Secure payment", desc: "Bancontact, PayPal, Klarna and card via Shopify Checkout." },
    ],
    product: {
      title: "Choose your flavor",
      sub: "One formula, two flavors. The same ingredients and doses in every tub.",
      flavorNote: { tropical: "Tropical fruit, sweet & fresh", apple: "Green apple, crisp & tart" },
      qty: "Quantity",
      add: "Add to cart",
      was: "List price",
      discount: "−19%",
      facts: ["20 servings per tub", "400 g net", "300 mg caffeine per serving", "Fully disclosed doses"],
      bundle: "Tip: 2 tubs = free shipping",
      shipping: "Shipping is calculated at checkout.",
    },
    ingredients: {
      title: "What's inside",
      sub: "Per serving of 1 scoop (20 g). No proprietary blends: every amount is listed below and on the label.",
      perServing: "per serving",
      other: "Other ingredients: natural flavors, citric acid, sweetener (sucralose), natural color, anti-caking agent (silicon dioxide).",
      items: {
        citrulline: "Compound of the amino acid L-citrulline and malic acid in a 2:1 ratio.",
        beta_alanine: "Amino acid. May cause a temporary tingling sensation shortly after intake (paresthesia). Harmless and passes on its own.",
        betaine: "Trimethylglycine in HCl form, naturally found in beets among other foods.",
        taurine: "Amino acid naturally present in the body and in food.",
        maltodextrin: "Fast-digesting carbohydrate derived from starch.",
        caffeine: "Anhydrous caffeine. 300 mg per serving — roughly three cups of coffee.",
        theanine: "Amino acid naturally found in green tea.",
        salt: "Natural salt, a source of sodium and trace minerals.",
        astragin: "Patented plant extract from Astragalus membranaceus and Panax notoginseng.",
      },
    },
    usage: {
      title: "How to use",
      steps: [
        { title: "Mix", desc: "Mix 1 scoop (20 g) with 300–400 ml cold water and shake well." },
        { title: "Timing", desc: "Take 20–30 minutes before training." },
        { title: "Dose", desc: "Max 1 serving per day. New to pre-workout? Start with half a scoop." },
      ],
      warning: "Contains 300 mg caffeine per serving. Not suitable for children, pregnant or breastfeeding women, or people sensitive to caffeine. Food supplement: not a substitute for a varied, balanced diet and healthy lifestyle. Keep out of reach of children.",
    },
    reviews: {
      title: "Reviews",
      sub: "Customer experiences. Tried ZENKAI? Share your opinion.",
      empty: "No reviews yet. Be the first to write one.",
      count: "{n} reviews",
      countOne: "1 review",
      average: "average",
      badge: "Customer review",
      write: "Write a review",
      cancel: "Cancel",
      name: "Name",
      sport: "Sport (optional)",
      flavor: "Flavor",
      rating: "Rating",
      text: "Your experience",
      textPlaceholder: "What did you think of the taste, use and ordering? Min. 10 characters.",
      submit: "Post review",
      sending: "Sending…",
      thanks: "Thanks! Your review is online.",
      error: "Something went wrong. Please try again.",
      tooMany: "You just posted a review. Try again in 2 minutes.",
      validation: "Enter your name, pick a rating and write at least 10 characters.",
    },
    faq: {
      title: "Frequently asked questions",
      items: [
        { q: "Why does my skin tingle after taking it?", a: "That's beta-alanine (paresthesia). It's harmless, fades after 20–30 minutes and usually decreases with regular use." },
        { q: "How much caffeine is in one serving?", a: "300 mg per scoop. Don't exceed 1 serving per day and account for other caffeine sources like coffee or energy drinks." },
        { q: "When will my order ship?", a: "Usually within 1–2 business days. Delivery in BE/NL typically takes 1–3 business days." },
        { q: "Can I return my order?", a: "Unopened products can be returned within 14 days of receipt. Contact us at info@mkbperformance.com." },
        { q: "How is payment handled?", a: "You check out via Shopify Checkout with Bancontact, PayPal, Klarna or card. Shipping costs are shown before you pay." },
      ],
    },
    contact: {
      title: "Contact",
      sub: "Question about your order, the product or anything else? Send a message — we usually reply within 1 business day.",
      name: "Name",
      email: "Email address",
      message: "Your question",
      messagePlaceholder: "How can we help?",
      send: "Send message",
      sending: "Sending…",
      thanks: "Thanks! Your message has been sent. We'll get back to you by email.",
      error: "Something went wrong. Try again or email us directly.",
      tooMany: "You just sent a message. Try again in a minute.",
      validation: "Enter your name, a valid email address and a message of at least 10 characters.",
      or: "Or email us directly at",
    },
    newsletter: {
      title: "Want to hear about new flavors first?",
      sub: "Leave your email. We only write when there are new products, flavors or deals — no spam.",
      placeholder: "you@email.com",
      cta: "Subscribe",
      sending: "One moment…",
      thanks: "You're on the list. See you soon!",
      already: "This address is already subscribed.",
      invalid: "Enter a valid email address.",
      error: "Something went wrong. Please try again.",
      privacy: "Unsubscribe anytime. We never share your address.",
    },
    footer: { rights: "© 2026 MKB Performance", contact: "Contact", email: "info@mkbperformance.com", legal: "Terms · Privacy · Returns" },
    cart: {
      title: "Cart",
      empty: "Your cart is empty.",
      subtotal: "Subtotal",
      shippingNote: "Shipping calculated at checkout",
      shippingAway: "{amount} away from free shipping",
      shippingFree: "Free shipping",
      checkout: "Checkout",
      continue: "Continue shopping",
    },
  },
  fr: {
    announcement: "Prix de lancement €32,50 (au lieu de €40) · Livraison gratuite dès €60",
    nav: { product: "Produit", ingredients: "Ingrédients", reviews: "Avis", faq: "FAQ", contact: "Contact", cart: "Panier", menu: "Menu" },
    hero: {
      eyebrow: "Nouveau chez MKB Performance",
      title: "ZENKAI Pre-Workout",
      sub: "Pré-workout à 9 ingrédients aux dosages entièrement indiqués. Ce qu'il contient est sur l'étiquette — ni plus, ni moins.",
      cta: "Voir ZENKAI",
      cta2: "Voir les ingrédients",
      from: "À partir de",
      perTub: "par pot (20 portions)",
    },
    trust: [
      { title: "Expédition rapide", desc: "Les commandes sont généralement expédiées sous 1 à 2 jours ouvrés." },
      { title: "Retour sous 14 jours", desc: "Les produits non ouverts peuvent être retournés sous 14 jours." },
      { title: "Paiement sécurisé", desc: "Bancontact, PayPal, Klarna et carte via Shopify Checkout." },
    ],
    product: {
      title: "Choisis ton goût",
      sub: "Une formule, deux goûts. Les mêmes ingrédients et dosages dans chaque pot.",
      flavorNote: { tropical: "Fruits tropicaux, sucré et frais", apple: "Pomme verte, fraîche et acidulée" },
      qty: "Quantité",
      add: "Ajouter au panier",
      was: "Prix conseillé",
      discount: "−19%",
      facts: ["20 portions par pot", "400 g net", "300 mg de caféine par portion", "Dosages entièrement indiqués"],
      bundle: "Astuce : 2 pots = livraison gratuite",
      shipping: "Les frais de port sont calculés au paiement.",
    },
    ingredients: {
      title: "Composition",
      sub: "Par portion de 1 dose (20 g). Pas de mélange propriétaire : chaque quantité est indiquée ci-dessous et sur l'étiquette.",
      perServing: "par portion",
      other: "Autres ingrédients : arômes naturels, acide citrique, édulcorant (sucralose), colorant naturel, antiagglomérant (dioxyde de silicium).",
      items: {
        citrulline: "Composé de l'acide aminé L-citrulline et d'acide malique dans un rapport 2:1.",
        beta_alanine: "Acide aminé. Peut provoquer des picotements passagers peu après la prise (paresthésie). Inoffensif, disparaît de lui-même.",
        betaine: "Triméthylglycine sous forme HCl, naturellement présente entre autres dans la betterave.",
        taurine: "Acide aminé naturellement présent dans l'organisme et l'alimentation.",
        maltodextrin: "Glucide à digestion rapide issu de l'amidon.",
        caffeine: "Caféine anhydre. 300 mg par portion — environ trois tasses de café.",
        theanine: "Acide aminé naturellement présent dans le thé vert.",
        salt: "Sel naturel, source de sodium et d'oligo-éléments.",
        astragin: "Extrait végétal breveté d'Astragalus membranaceus et de Panax notoginseng.",
      },
    },
    usage: {
      title: "Utilisation",
      steps: [
        { title: "Mélanger", desc: "Mélange 1 dose (20 g) dans 300–400 ml d'eau froide et secoue bien." },
        { title: "Timing", desc: "À prendre 20–30 minutes avant l'entraînement." },
        { title: "Dosage", desc: "Maximum 1 portion par jour. Débutant ? Commence par une demi-dose." },
      ],
      warning: "Contient 300 mg de caféine par portion. Déconseillé aux enfants, aux femmes enceintes ou allaitantes et aux personnes sensibles à la caféine. Complément alimentaire : ne remplace pas une alimentation variée et équilibrée ni un mode de vie sain. Tenir hors de portée des enfants.",
    },
    reviews: {
      title: "Avis",
      sub: "Expériences de clients. Tu as essayé ZENKAI ? Partage ton avis.",
      empty: "Pas encore d'avis. Sois le premier à en écrire un.",
      count: "{n} avis",
      countOne: "1 avis",
      average: "moyenne",
      badge: "Avis client",
      write: "Écrire un avis",
      cancel: "Annuler",
      name: "Nom",
      sport: "Sport (optionnel)",
      flavor: "Goût",
      rating: "Note",
      text: "Ton expérience",
      textPlaceholder: "Qu'as-tu pensé du goût, de l'utilisation et de la commande ? Min. 10 caractères.",
      submit: "Publier l'avis",
      sending: "Envoi…",
      thanks: "Merci ! Ton avis est en ligne.",
      error: "Une erreur est survenue. Réessaie.",
      tooMany: "Tu viens de publier un avis. Réessaie dans 2 minutes.",
      validation: "Indique ton nom, choisis une note et écris au moins 10 caractères.",
    },
    faq: {
      title: "Questions fréquentes",
      items: [
        { q: "Pourquoi ma peau picote après la prise ?", a: "C'est la bêta-alanine (paresthésie). Inoffensif, cela disparaît après 20–30 minutes et diminue généralement avec un usage régulier." },
        { q: "Combien de caféine par portion ?", a: "300 mg par dose. Ne dépasse pas 1 portion par jour et tiens compte des autres sources de caféine (café, boissons énergisantes)." },
        { q: "Quand ma commande est-elle expédiée ?", a: "Généralement sous 1 à 2 jours ouvrés. Livraison en BE/NL en 1 à 3 jours ouvrés en moyenne." },
        { q: "Puis-je retourner ma commande ?", a: "Les produits non ouverts peuvent être retournés sous 14 jours après réception. Contacte-nous à info@mkbperformance.com." },
        { q: "Comment se passe le paiement ?", a: "Tu paies via Shopify Checkout avec Bancontact, PayPal, Klarna ou carte. Les frais de port sont affichés avant le paiement." },
      ],
    },
    contact: {
      title: "Contact",
      sub: "Une question sur ta commande, le produit ou autre ? Envoie un message — nous répondons généralement sous 1 jour ouvré.",
      name: "Nom",
      email: "Adresse e-mail",
      message: "Ta question",
      messagePlaceholder: "Comment pouvons-nous t'aider ?",
      send: "Envoyer le message",
      sending: "Envoi…",
      thanks: "Merci ! Ton message a été envoyé. Nous te répondrons par e-mail.",
      error: "Une erreur est survenue. Réessaie ou écris-nous directement.",
      tooMany: "Tu viens d'envoyer un message. Réessaie dans une minute.",
      validation: "Indique ton nom, une adresse e-mail valide et un message d'au moins 10 caractères.",
      or: "Ou écris-nous directement à",
    },
    newsletter: {
      title: "Être le premier informé des nouveaux goûts ?",
      sub: "Laisse ton e-mail. Nous écrivons uniquement pour de nouveaux produits, goûts ou promos — pas de spam.",
      placeholder: "toi@email.com",
      cta: "S'inscrire",
      sending: "Un instant…",
      thanks: "Tu es sur la liste. À bientôt !",
      already: "Cette adresse est déjà inscrite.",
      invalid: "Indique une adresse e-mail valide.",
      error: "Une erreur est survenue. Réessaie.",
      privacy: "Désinscription possible à tout moment. Nous ne partageons jamais ton adresse.",
    },
    footer: { rights: "© 2026 MKB Performance", contact: "Contact", email: "info@mkbperformance.com", legal: "Conditions générales · Confidentialité · Retours" },
    cart: {
      title: "Panier",
      empty: "Ton panier est vide.",
      subtotal: "Sous-total",
      shippingNote: "Frais de port calculés au paiement",
      shippingAway: "Plus que {amount} pour la livraison gratuite",
      shippingFree: "Livraison gratuite",
      checkout: "Passer au paiement",
      continue: "Continuer mes achats",
    },
  },
};
